export default "__VITE_ASSET__DQcVdmpj__"